import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import styled from "styled-components";
import {
  Headline4,
  LargeText,
  RegularText,
} from "~/shared/components/typography";
import {
  Flex,
  FlexColumn,
  FlexRowSpaceBetween,
} from "~/shared/components/flexes";
import { usePosts, useSearch } from "~/shared/hooks";

import FadeInChildren from "~/shared/components/FadeInChildren";

import { Input } from "semantic-ui-react";

import Post from "./Post";
import About from "./About";
import PostItem from "./PostItem";
import WhatsappButton from "./WhatsappButton";

const Wrapper = styled(FlexColumn)`
  padding: 35px 20px;
  max-width: 800px;
  margin: 0 auto;
`;

const Hero = styled(FlexRowSpaceBetween)`
  margin-bottom: 25px;
`;

const Texts = styled(FlexColumn)`
  gap: 10px;
`;

const Title = styled(Headline4)`
  font-weight: 600;
`;

const SubTitle = styled(LargeText)``;

const AboutLink = styled(Link)`
  font-weight: 600;
  font-size: 16px;
  align-self: flex-end;
`;

const InputWrapper = styled(Flex)`
  margin-bottom: 20px;
`;

const FinalLine = styled(RegularText)`
  font-weight: 600;
  margin-top: 5px;
`;

const PostList = styled(FlexColumn)`
  gap: 35px;
`;

function App() {
  const { querySearch, inputSearchValue, onSearch } = useSearch();
  const { loading, data } = usePosts({ search: querySearch });

  return (
    <Wrapper>
      <Router>
        <Switch>
          <Route path="/about" exact>
            <About />
          </Route>

          <Route path="/posts/:id" exact>
            <Post posts={data?.posts} />
          </Route>

          <Route path="/">
            <Hero>
              <Texts>
                <Title>מו״ר הרב אברהם יהושע צוקרמן זצ״ל </Title>

                <SubTitle>
                  בכאב גדול התחלנו ללקט{" "}
                  <strong>הספדים, זכרונות וסיפורים,</strong> להתחיל להאיר במקצת
                  את דמותו המופלאה של רבנו
                </SubTitle>

                <FinalLine>
                  נשמח מאד שגם אתם תצטרפו ותקחו חלק בהארת דמותו של רבנו
                </FinalLine>

                <WhatsappButton />

                <AboutLink to="/about">לכמה מילים עלינו..</AboutLink>
              </Texts>
            </Hero>

            <InputWrapper>
              <Input
                style={{
                  width: "100%",
                }}
                value={inputSearchValue}
                placeholder="חיפוש..."
                onChange={onSearch}
              />
            </InputWrapper>

            <PostList>
              {loading ? (
                <p>רק שניה...</p>
              ) : (
                data?.posts.map((post) => (
                  <FadeInChildren>
                    <PostItem {...post} />
                  </FadeInChildren>
                ))
              )}
            </PostList>
          </Route>
        </Switch>
      </Router>
    </Wrapper>
  );
}

export default App;
